export const rankingTypes = ['all', 'friends'] as const;

export type RankingType = (typeof rankingTypes)[number];
